import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import { Grid } from '@mui/material';
import AnimateButton from 'ui-component/extended/AnimateButton';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4
};

export default function BasicModal({
    open,
    handleClose,
    title,
    description,
    onDelete,
    children,
    width = 400,
    confirming = false,
    confirmLabel = 'Sim',
    confirmingText = 'Aguarde, a operação está em andamento.'
}) {
    const onClose = (event, reason) => {
        if (confirming) return;
        handleClose(event, reason);
    };

    return (
        <div>
            <Modal open={open} onClose={onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={{ ...style, width }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {title}
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        {description}
                    </Typography>
                    {confirming ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 3 }}>
                            <CircularProgress size={28} />
                            <Typography>{confirmingText}</Typography>
                        </Box>
                    ) : (
                        children
                    )}
                    <Grid container alignItems="end" justifyContent="end" sx={{ mt: 3 }}>
                        <Grid item>
                            <Box sx={{ mt: 2, mr: 3 }}>
                                <AnimateButton>
                                    <Button
                                        disableElevation
                                        disabled={confirming}
                                        size="medium"
                                        type="button"
                                        variant="contained"
                                        color="error"
                                        onClick={onClose}
                                    >
                                        Não
                                    </Button>
                                </AnimateButton>
                            </Box>
                        </Grid>
                        <Grid item>
                            <Box sx={{ mt: 2, mr: 3 }}>
                                <AnimateButton>
                                    <Button
                                        disableElevation
                                        disabled={confirming}
                                        size="medium"
                                        type="button"
                                        variant="contained"
                                        color="primary"
                                        onClick={(event) => {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            if (confirming) return;
                                            onDelete?.(event);
                                        }}
                                    >
                                        {confirming ? 'Aguarde...' : confirmLabel}
                                    </Button>
                                </AnimateButton>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    );
}
